export enum QUERY_KEYS {
  IMAGE = 'IMAGE',
  IMAGES = 'IMAGES',
}

export default QUERY_KEYS
